import React from "react";

const JobFieldsList: React.FC = () => {
  return (
    <div className="mt-4 border-t border-blue-200 pt-3">
      <p className="font-medium text-blue-600 mb-2">Please mention these fields:</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 text-xs text-gray-600">
        <div className="bg-blue-50/50 p-2 rounded">
          <p className="font-medium text-blue-600 mb-1">Job Details:</p>
          <ul className="space-y-1">
            <li>
              <span className="font-medium">Title:</span> "Software Engineer"
            </li>
            <li>
              <span className="font-medium">Description:</span> "Building web apps"
            </li>
            <li>
              <span className="font-medium">Location:</span> "Remote" or "New York"
            </li>
            <li>
              <span className="font-medium">Vacancies:</span> "3 positions"
            </li>
          </ul>
        </div>

        <div className="bg-blue-50/50 p-2 rounded">
          <p className="font-medium text-blue-600 mb-1">Skills & Requirements:</p>
          <ul className="space-y-1">
            <li>
              <span className="font-medium">Skills:</span> "React, TypeScript"
            </li>
            <li>
              <span className="font-medium">Experience:</span> "2-5 years"
            </li>
            <li>
              <span className="font-medium">Languages:</span> "English required"
            </li>
            <li>
              <span className="font-medium">Documents:</span> "Resume, ID"
            </li>
            <li>
              <span className="font-medium">Age:</span> "21-65 years"
            </li>
          </ul>
        </div>

        <div className="bg-blue-50/50 p-2 rounded sm:col-span-2 lg:col-span-1">
          <p className="font-medium text-blue-600 mb-1">Contract & Salary:</p>
          <ul className="space-y-1">
            <li>
              <span className="font-medium">Contract:</span> "Full-time"
            </li>
            <li>
              <span className="font-medium">Salary:</span> "$25-35/hour"
            </li>
            <li>
              <span className="font-medium">Payment:</span> "Monthly"
            </li>
            <li>
              <span className="font-medium">Performance:</span> "Meet targets"
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default JobFieldsList;
